import React from 'react';
import InspectionCompletenessSection from './InspectionCompletenessSection';

// The section is shared with the Slope dashboard — see InspectionCompletenessSection
// for the full implementation and the per-kind (slope/bridge) configuration.
const BridgeInspectionCompletenessSection = () => <InspectionCompletenessSection kind="bridge" />;

export default BridgeInspectionCompletenessSection;
